import {Component} from 'react';
import h from 'react-hyperscript';
import {p} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
// eslint-disable-next-line max-len
import SurveyMessaging from 'Pages/ReportCardOverview/SurveyReportStatus/SurveyMessaging/SurveyMessaging';
import SurveyStats from './SurveyStats/SurveyStats';
import {SURVEY} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
// eslint-disable-next-line max-len
import {replaceReportAvailableDatePlaceholder, replaceCloseDatePlaceholder, replaceReportNamePlaceholder} from 'Src/utils/utils';

class SurveyAvailableState extends Component {
  sanitize(string) {
    const date = new Date(this.props.expirationDate.replace('-', '/'));
    const reportName = this.props.latestReport.report_card_name;
    return replaceReportAvailableDatePlaceholder(
        replaceReportNamePlaceholder(string, reportName),
        date);
  }

  sanitizeContent(subtitle) {
    const reportName = this.props.latestReport.report_card_name;
    const expirationDate = new Date(
        this.props.userStatus.dates.survey_close_date
            .replace('-', '/')
    );
    return replaceCloseDatePlaceholder(
        replaceReportNamePlaceholder(subtitle, reportName),
        expirationDate
    );
  }


  render() {
    const expirationDate = this.props.expirationDate;
    const onSurveyClick = (e) => {
      pushGTMEvent(SURVEY.TAG, {
        event: SURVEY.EVENT,
        action: {survey_action: SURVEY.ACTION.START},
      });
    };

    return h(
        BasicCard,
        {
          type: 'basic',
          className: 'report-overview__status status--no-report flex',
          id: `report-overview--${this.props.content.statusId}`,
        },
        h(
            'div',
            {
              className: 'flex--space-between flex--wrap',
            },
            [
              h(
                  SurveyMessaging,
                  {
                    surveyTitle: this.props.surveyTitle,
                    title: this.sanitize(this.props.content.title),
                    latestReport: this.props.latestReport,
                    districtId: this.props.userStatus.district_id,
                    ctas: this.props.content.ctas,
                    googleUser: this.props.googleUser,
                    csrf: this.props.csrf,
                    idToken: this.props.idToken,
                    userStatus: this.props.userStatus,
                    expirationDate,
                    statusId: this.props.content.statusId,
                    shareUrl: this.props.shareUrl,
                    shareInfo: this.props.shareInfo,
                    onSurveyClick,
                    setProductWindowsLoading:
                      this.props.setProductWindowsLoading,
                    SubtitleComponent: h(
                        'div',
                        {
                          key: `survey-messaging-subtitle--${
                            this.props.content.subtitle
                          }`,
                          className: 'survey-messaging__subtitle',
                        },
                        [
                          h(
                              p,
                              {
                                className: 'text--grey',
                                dangerouslySetInnerHTML:
                                    this.sanitizeContent(
                                        this.props.content.subtitle),
                              },
                              null,
                          ),
                        ]
                    ),
                  },
                  null
              ),
          expirationDate ?
            h(
                SurveyStats,
                {
                  respondents: this.props.numRespondents,
                  expirationDate,
                  daysLeft: this.props.daysLeft,
                },
                null
            ) :
            null,
            ]
        )
    );
  }
}

export default SurveyAvailableState;
